import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';
import { DataService } from '@data/data.service';

@Component({
  selector: 'app-change-customer-dialog',
  templateUrl: './change-customer-dialog.component.html',
  styleUrls: ['./change-customer-dialog.component.scss'],
})
export class ChangeCustomerDialogComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  constructor(public dataService: DataService, public authService: AuthService) {}

  ngOnInit() {
    this.authService.changeCustomerDialog$
      .pipe(
        filter((x) => !!x),
        takeUntil(this.destroy$)
      )
      .subscribe((x) => this.dataService.hideScreen$.next(!!x));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  public showDialog(show: boolean = true) {
    this.authService.changeCustomerDialog$.next(show);
    this.dataService.hideScreen$.next(show);
  }
}
